import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const NativeCachedImage = () => {
    return _jsx(_Fragment, {});
};
export default NativeCachedImage;
